import React from 'react';
import { array, number } from 'prop-types';

import { connect } from 'react-redux';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';

import * as WizardActions from '../../../actions/wizardActions';

import classes from './WizardStepper.module.css';

const WizardStepper = ({
    activeStep,
    agentName,
    equipmentTypeName,
    profileName,
    steps,
    ...props
}) => {
    const getCaption = index => {
        switch (index) {
            case 0:
                return agentName;
            case 1:
                return profileName;
            case 2:
                return equipmentTypeName;
            default:
                break;
        }
    };

    return (
        <Stepper
            activeStep={activeStep}
            classes={{
                root: classes.stepperWrapper
            }}
        >
            {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};

                if (getCaption(index)) {
                    labelProps.optional =
                        <Typography
                            variant="caption"
                            classes={{
                                root: classes.stepCaption
                            }}
                        >
                            {getCaption(index)}
                        </Typography>;
                }

                return (
                    <Step
                        key={label}
                        {...stepProps}
                    >
                        <StepLabel
                            classes={{
                                root: classes.step
                            }}
                            StepIconProps={{
                                classes: {
                                    root:      classes.stepIcon,
                                    completed: classes.stepIconCompleted
                                }
                            }}
                            {...labelProps}
                        >
                            {label}
                        </StepLabel>
                    </Step>
                );
            })}
        </Stepper>
    );
};

WizardStepper.defaultProps = {
    activeStep: 0,
    steps:      []
};

WizardStepper.propTypes = {
    activeStep: number,
    steps:      array
};

const mapStateToProps = state => {
    return {
        activeStep:        state.wizard.activeStep,
        agentName:         state.wizard.agentName,
        equipmentTypeName: state.wizard.equipmentTypeName,
        profileName:       state.wizard.profileName,
        steps:             state.wizard.steps
    };
};

const mapDispatchToProps = {
    ...WizardActions
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardStepper);
